import { Component, ElementRef, HostListener, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';

import * as echarts from 'echarts/core';
import {
  TitleComponent,
  ToolboxComponent,
  TooltipComponent,
  DataZoomComponent,
} from 'echarts/components';
import { GridComponent, GridComponentOption } from 'echarts/components';
import { BarChart, BarSeriesOption } from 'echarts/charts';
import { CanvasRenderer } from 'echarts/renderers';
import { SimpleChartBar } from 'src/app/Interfaces/Admin/charts/SimpleCharBar.interface';
import { LargeChartBar } from 'src/app/Interfaces/Admin/charts/LargeCharBar.interface';

interface DataYBar {
  value: number,
  itemStyle: colorBar
}

interface colorBar {
  color: string
}

@Component({
    selector: 'app-large-chart-bar-cdms',
    templateUrl: './large-chart-bar-cdms.component.html',
    styleUrls: ['./large-chart-bar-cdms.component.scss', '../../../../Components/Styles/GlobalStyles.css'],
    standalone: false
})
export class LargeChartBarCDMSComponent implements OnInit, OnChanges {

  //+===================== INPUTS =====================+\\
  @Input() DataChartBar!: LargeChartBar;

  //+================== VARIABLES FOR CHART ==================+\\
  @ViewChild('largeBarChart', { static: true }) chartContainer!: ElementRef;

  private MyChart!: echarts.ECharts;

  ngOnInit(): void {
    echarts.use([GridComponent, BarChart, CanvasRenderer, TitleComponent,
      DataZoomComponent, TooltipComponent,]);

    this.MyChart = echarts.init(this.chartContainer.nativeElement);
    this.updateChart();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['DataChartBar'] && !changes['DataChartBar'].firstChange) {
      this.updateChart();
    }
  }

  private getChartOptions() {

    var option;

    const color: string[] = ['#147496', '#1785AD', '#188FBA', '#1B9DCC', '#1CA5D6', '#21AEEB', '#24BDFF', '#24D5FF', '#24FAFF', '#3CFFFF', '#7BFFFF', '#AEFFFF', '#C8FFFF', '#AEFFFF', '#7BFFFF', '#3CFFFF', '#24FAFF', '#24D5FF', '#24BDFF', '#21AEEB', '#21AEEB', '#1CA5D6', '#1B9DCC', '#188FBA', '#1785AD', '#147496', '#0F5A75', '#0B3F52', '#072834'];
    const dataBarsY: DataYBar[] = this.DataChartBar.DataY.map((Y: number, index: number) => {
      return { value: Y, itemStyle: { color: color[index % color.length] } }
    })

    option = {
      title: {
        left: 'center',
        text: this.DataChartBar.Title,
        subtext: this.DataChartBar.subtitle,
      },
      xAxis: {
        type: 'category',
        data: this.DataChartBar.DataX
      },
      yAxis: {
        type: 'value',
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        }
      },
      dataZoom: [
        {
          type: 'inside'
        },
        {
          type: 'slider'
        }
      ],
      series: [
        {
          data: dataBarsY,
          type: 'bar',
        }
      ]
    };

    return option
  }

  //-================== LOAD CHART OPTIONS AND DATA ==================-\\
  private updateChart(): void {
    const options = this.getChartOptions();
    this.MyChart.resize();
    this.MyChart.setOption(options);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    if (this.MyChart) {
      this.MyChart.resize();
    }
  }
}
